import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { getAction, fetchAction, updateAction } from '../../../ducks/actions'
import Button from '../../Shared/Button'
import Subnav from '../../Shared/Subnav'
import Pipe from '../../Shared/Pipe'
import { FullScreenLoader } from '../../Shared/Loading'

import ActionName from './ActionName'
import Inputs from './Inputs'
import Steps from './Steps'

import styles from './Configure.module.css'

export default function Configure({ match, history }) {
  const [saving, setSaving] = useState(false)
  const [blankName, setBlankName] = useState(false)
  const { id } = match.params
  const dispatch = useDispatch()
  const action = useSelector(getAction(id))

  useEffect(() => {
    dispatch(fetchAction(id))
  }, [dispatch, id])

  const handleSave = async () => {
    setSaving(true)

    try {
      await dispatch(updateAction(id, { draft: false }))
      history.push(`/actions/${id}`)
    } catch (err) {
      console.error(err)
    }

    setSaving(false)
  }

  if (!action || !action.details) {
    return <FullScreenLoader />
  }

  return (
    <>
      <Subnav
        title="Configure Action"
        actions={
          <>
            {action.draft ? (
              <Button
                onClick={handleSave}
                loading={saving}
                disabled={blankName}
              >
                Finish Action
              </Button>
            ) : (
              <Button to={`/actions/${id}`} disabled={blankName}>
                Done
              </Button>
            )}
          </>
        }
      />
      <ActionName action={action} setBlankName={setBlankName} />
      <Inputs action={action} />
      <Pipe />
      <Steps action={action} />
      <div className={styles.addStepWrapper}>
        <Button icon="add" to={`/actions/${id}/add-step`} color="grey">
          Add Step
        </Button>
      </div>
    </>
  )
}
